import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { TransactionListItem } from "@common/schemas/transaction.schema";

/**
 * Memo comparator for transaction table cell components.
 * Use as the second argument to React.memo().
 * Re-renders when row.original or table instance changes (row.original uses
 * referential equality from React Query; table changes when tableMeta updates).
 * Also re-renders when the column definition changes (e.g. column meta updates
 * like Category column variant changes).
 */
export function transactionCellAreEqual<T>(
    prev: CellContext<ViewTableFeatures, TransactionListItem, T>,
    next: CellContext<ViewTableFeatures, TransactionListItem, T>,
): boolean {
    return (
        prev.row.original === next.row.original &&
        prev.table === next.table &&
        prev.column.columnDef === next.column.columnDef
    );
}
